import {
    UPDATE_COST_CENTER, UPDATE_COST_CENTER_RESPONSE,
    ISVEHICLECONSOLIDATEDCHECKED,
    ISMANAGEEQUIPCONSOLIDATEDCHECKED,
    ISNONSTANDARDCONSOLIDATEDCHECKED,
    GET_FLEET_PO,
    SET_FLEET_PO,
    SET_DISPOSITION_DATA,
    SET_TRANSFER_DATA,
    IS_SAVE_PURCHASE_ORDER_LOADING,
    SET_INITIAL_DISPOSITION_DATA,
    VALIDATE_AND_SAVE_MULTIPLE_PO,
    SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS,
    CREATE_CONSOLIDATED_PO,
    CREATE_CONSOLIDATED_PO_RESPONSE
} from "./FleetProcessingType"

const updateCostCenter = (value: any) => {
    return {
      type: UPDATE_COST_CENTER,
      costCenter: value,
    };
  };

const updateCostCenterResponse = (value: any) => {
  return {
    type: UPDATE_COST_CENTER_RESPONSE,
    isCostCenterUpdated: value,
  };
};

const setOnVehicleConsolidatedChecked = (data: any) => ({
  type: ISVEHICLECONSOLIDATEDCHECKED,
  isChecked: data,
});

const setOnManageEquipConsolidatedChecked = (data: any) => ({
  type: ISMANAGEEQUIPCONSOLIDATEDCHECKED,
  isChecked: data,
});

const setOnNonstandardConsolidatedChecked = (data: any) => ({
  type: ISNONSTANDARDCONSOLIDATEDCHECKED,
  isChecked: data,
});

const setIsSavePurchaseOrderLoading = (data: any) => ({
  type: IS_SAVE_PURCHASE_ORDER_LOADING,
  isLoading: data,
});

const getFleetPo = (data: any) => ({
  type: GET_FLEET_PO,
  payload: data,
});

const setFleetPo = (value: any) => {
  return {
    type: SET_FLEET_PO,
    payload: value,
  };
};

const setDispositionData = (dispositionData: any) => {
  return {
    type: SET_DISPOSITION_DATA,
    dispositionData: dispositionData,
  };
};

const setTransferData = (transferData: any) => {
  return {
    type: SET_TRANSFER_DATA,
    transferData: transferData,
  };
};

const setInitialDispositionData = (dispositionData: any) => {
  return {
    type: SET_INITIAL_DISPOSITION_DATA,
    initialDispositionData: dispositionData,
  };
};

const validateAndSavePO = (data: any) => ({
  type: VALIDATE_AND_SAVE_MULTIPLE_PO,
  payload: data,
});

const setValidateAndSavePOSuccess = (data: any) => ({
  type: SET_VALIDATE_AND_SAVE_MULTIPLE_PO_SUCCESS,
  validateAndSaveMultiplePoSuccess: data,
});

const getConsolidatedFleetPo = (data: any) => ({
  type: CREATE_CONSOLIDATED_PO,
  payload: data,
});

const setConsolidatedFleetPo = (value: any) => {
  return {
    type: CREATE_CONSOLIDATED_PO_RESPONSE,
    payload: value,
  };
};

export {
    updateCostCenter,
    updateCostCenterResponse,
    setOnVehicleConsolidatedChecked,
    setOnManageEquipConsolidatedChecked,
    setOnNonstandardConsolidatedChecked,
    setIsSavePurchaseOrderLoading,
    getFleetPo,
    setFleetPo,
    setDispositionData,
    setTransferData,
    setInitialDispositionData,
    validateAndSavePO,
    setValidateAndSavePOSuccess,
    getConsolidatedFleetPo,
    setConsolidatedFleetPo
}
